import React from 'react';
/* This files links all pages components "entry points" of a project */
// MODULES_APPEND_INDEX_ON_IMPORTS

export const modules = [
  {
    id: 'PortadaPage',
    loader: React.lazy(() => import('../../src/pages/PortadaPage')),
  },
  {
    id: 'FichasPage',
    loader: React.lazy(() => import('../../src/pages/FichasPage')),
  },
  {
    id: 'OfertasPage',
    loader: React.lazy(() => import('../../src/pages/OfertasPage')),
  },
  {
    id: 'SolarPage',
    loader: React.lazy(() => import('../../src/pages/SolarPage')),
  },
  // MODULES_APPEND_INDEX_ON_MODULES
]
